import React, { useEffect, useState, useCallback } from "react";
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { InflationRateAPI } from '../../../API/inflation_rate'
import { SelicCdiIpcaAPI } from '../../../API/selicCdiIpca'

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import MySelect from '../../utils/MySelect'
import { MyTab, MyTabs } from '../../utils/MyTabs'

import moment from 'moment'

import { getShortMonths, getYearsByYearUntilNow } from '../../utils/utils';

import { unoTheme, tabs } from '../../../assets/styles/unoTheme'

import _ from 'lodash';

import { Line } from 'react-chartjs-2';

const color = unoTheme.chartColors;

const optionsChart2 = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'bottom',
        fullWidth: true,
    },
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    tabs: tabs,
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: theme.spacing(2),
        alignItems: 'center',
    },
    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    leftHeaderDetail: {
        display: "flex",
        alignItems: "baseline",
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },
    tableTh: {
        fontWeight: 'bold'
    },
    blue: {
        color: 'blue',
    },
    main: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        width: '100%',
        borderRadius: '10px 0px 0px 10px',
        backgroundColor: 'white',
    },
    divTable: {
        width: '40%',
        maxWidth: '40%',
    },
    divChart: {
        width: '60%',
        maxWidth: '60%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(3),

        '& .chartHeader': {
            minHeight: '56px',
            height: '56px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%',
            paddingTop: theme.spacing(2),
            paddingBottom: '12px',
            paddingRight: '13px',
            '& .MuiTypography-root': {
                marginRight: theme.spacing(1),
            }
        },

        '& .chartWrapper': {
            height: '450px',
            width: '100%',
        }
    },
}));


export default function InflationRatesScreen() {

    const classes = useStyles();

    const dispatch = useDispatch();
    const rightContent = useSelector(state => state.rightContent);

    const [tabValue, setTabValue] = useState(0);

    // --- Tab 0: IPCA / INPC ---
    const [inflationRates, setInflationRates] = useState([]);
    const [years, setYears] = useState([]);
    const [dataToShow, setDataToShow] = useState([]);
    const [dataByYears, setDataByYears] = useState(null);
    const [dataChart, setDataChart] = useState(null);
    const [yearChartSelected, setYearChartSelected] = useState(null);
    const [typesChart] = useState(['Valores mensais', 'Valores acumulados']);
    const [typeChartSelected, setTypeChartSelected] = useState(null);

    // --- Tab 1: SELIC / CDI / IPCA ---
    const [selicCdiIpcaToShow, setSelicCdiIpcaToShow] = useState([]);

    async function doGetInflationRates() {
        const response = await InflationRateAPI.getInflationRates();
        if (response.success) {
            setInflationRates(response.body.rows);
            let yrs = getYearsByYearUntilNow(2015);
            let yearsReverse = _.cloneDeep(yrs);
            yearsReverse.reverse();
            setYears(yearsReverse);
            formatDataToShow(yrs, response.body.rows);
        } else {
            console.log("RESPONSE ERROR: ", response.error);
        }
    }

    async function doGetSelicCdiIpca() {
        const response = await SelicCdiIpcaAPI.getAll();
        if (response.success) {
            const yrs = getYearsByYearUntilNow(2015);
            formatDataToShowSelicCdiIpca(yrs, response.body.rows);
        } else {
            console.log("SELIC CDI IPCA ERROR: ", response.error);
        }
    }

    const handleChangeTypeChartYear = (value) => {
        setTypeChartSelected(value);
        formatDataToChart(years[yearChartSelected], dataByYears, value);
    };

    const handleChangeChartYear = (value) => {
        setYearChartSelected(value);
        formatDataToChart(years[value], dataByYears, typeChartSelected);
    };

    function getDataChart(d1, d2) {
        return {
            labels: getShortMonths(),
            type: 'line',
            datasets: [
                {
                    label: 'IPCA',
                    backgroundColor: "transparent",
                    borderColor: color[1],
                    pointBackgroundColor: color[1],
                    pointBorderColor: color[1],
                    pointHoverBackgroundColor: color[1],
                    pointHoverBorderColor: color[1],
                    data: d1
                },
                {
                    label: 'INPC',
                    backgroundColor: "transparent",
                    borderColor: color[2],
                    pointBackgroundColor: color[2],
                    pointBorderColor: color[2],
                    pointHoverBackgroundColor: color[2],
                    pointHoverBorderColor: color[2],
                    data: d2
                },
            ]
        };
    }

    function formatDataToChart(year, localDataByYears, type) {
        let dataChartIPCA = [];
        let dataChartINPC = [];

        if (type == 1) {
            for (let m = 1; m <= 12; m++) {
                dataChartIPCA.push({
                    y: localDataByYears[year].inflationRates[m] && localDataByYears[year].inflationRates[m].ipcaAcum
                        ? parseFloat(localDataByYears[year].inflationRates[m].ipcaAcum) : 0,
                    id: 'IPCA-' + year + '-' + m,
                });
                dataChartINPC.push({
                    y: localDataByYears[year].inflationRates[m] && localDataByYears[year].inflationRates[m].inpcAcum
                        ? parseFloat(localDataByYears[year].inflationRates[m].inpcAcum) : 0,
                    id: 'INPC-' + year + '-' + m,
                });
            }
        } else {
            for (let m = 1; m <= 12; m++) {
                dataChartIPCA.push({
                    y: localDataByYears[year].inflationRates[m] && localDataByYears[year].inflationRates[m].ipca
                        ? parseFloat(localDataByYears[year].inflationRates[m].ipca) : 0,
                    id: 'IPCA-' + year + '-' + m,
                });
                dataChartINPC.push({
                    y: localDataByYears[year].inflationRates[m] && localDataByYears[year].inflationRates[m].inpc
                        ? parseFloat(localDataByYears[year].inflationRates[m].inpc) : 0,
                    id: 'INPC-' + year + '-' + m,
                });
            }
        }

        setDataChart(getDataChart(dataChartIPCA, dataChartINPC));
    }

    function formatDataToShow(yrs, rates) {
        let localDataByYears = {};
        let dataToShow = [];
        let monthsInflationRates = {};

        yrs.forEach(element => {
            let inflationRatesYear = rates.filter(el => element == el.year);

            let ipcaAcum = 1;
            let inpcAcum = 1;
            inflationRatesYear.forEach(ir => {
                ipcaAcum *= ir.ipca ? (1 + (parseFloat(ir.ipca) / 100)) : 1;
                inpcAcum *= ir.inpc ? (1 + (parseFloat(ir.inpc) / 100)) : 1;
                ir.ipcaAcum = parseFloat(parseFloat((ipcaAcum - 1) * 100).toFixed(2));
                ir.inpcAcum = parseFloat(parseFloat((inpcAcum - 1) * 100).toFixed(2));
                monthsInflationRates[ir.month] = ir;
            });

            let inflationRateToPush = {
                year: element,
                ipcaAcum: parseFloat((ipcaAcum - 1) * 100).toFixed(2),
                inpcAcum: parseFloat((inpcAcum - 1) * 100).toFixed(2),
                inflationRates: monthsInflationRates,
            };

            dataToShow.push(inflationRateToPush);
            monthsInflationRates = {};
            localDataByYears[element] = inflationRateToPush;
        });

        dataToShow.reverse();
        setDataToShow(dataToShow);
        setDataByYears(localDataByYears);

        let lastYear = yrs[yrs.length - 1];
        setYearChartSelected(0);
        formatDataToChart(lastYear, localDataByYears, 0);
    }

    function formatDataToShowSelicCdiIpca(yrs, rows) {
        const result = [];

        yrs.forEach(year => {
            const yearRows = rows.filter(r => r.year == year);
            let selicAcum = 1;
            let cdiAcum = 1;
            let ipcaAcum = 1;
            const records = {};

            yearRows.forEach(r => {
                selicAcum *= r.selic != null ? (1 + parseFloat(r.selic) / 100) : 1;
                cdiAcum *= r.cdi != null ? (1 + parseFloat(r.cdi) / 100) : 1;
                ipcaAcum *= r.ipca != null ? (1 + parseFloat(r.ipca) / 100) : 1;
                records[r.month] = r;
            });

            result.push({
                year,
                selicAcum: parseFloat((selicAcum - 1) * 100).toFixed(2),
                cdiAcum: parseFloat((cdiAcum - 1) * 100).toFixed(2),
                ipcaAcum: parseFloat((ipcaAcum - 1) * 100).toFixed(2),
                records,
            });
        });

        result.reverse();
        setSelicCdiIpcaToShow(result);
    }

    useEffect(() => {
        if (dataToShow.length === 0) {
            doGetInflationRates();
        }
        if (selicCdiIpcaToShow.length === 0) {
            doGetSelicCdiIpca();
        }

        if (rightContent && rightContent.action) {
            if (tabValue === 0) {
                doGetInflationRates();
            } else {
                doGetSelicCdiIpca();
            }
            dispatch(allActions.rightContentActions.setRightContent(null));
        }
    }, [rightContent]);

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>
                <div className={classes.tabs}>
                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(e, newValue) => setTabValue(newValue)}>
                        <MyTab label="IPCA / INPC" value={0} />
                        <MyTab label="SELIC / CDI / IPCA (Projetados)" value={1} />
                    </MyTabs>
                </div>
            </div>

            <div class={'defaultScrollWithHeaderContent'}>

                {/* Tab 0: IPCA / INPC */}
                {tabValue === 0 &&
                    <div className={classes.main}>
                        <div className={classes.divTable}>
                            <MyTable stickyHeader size="small" selectable='true'>
                                <colgroup>
                                    <col width="40%" />
                                    <col width="30%" />
                                    <col width="30%" />
                                </colgroup>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">Ano</TableCell>
                                        <TableCell align="right">IPCA</TableCell>
                                        <TableCell align="right">INPC</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataToShow.map((row) => (
                                        <TableRow
                                            key={'inflation-rate-' + row.year}
                                            onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                                path: 'newInflationRate',
                                                data: row,
                                            }))}>
                                            <TableCell align="left">{row.year}</TableCell>
                                            <TableCell align="right" className={classes.blue}>{row.ipcaAcum ? row.ipcaAcum + "%" : '-'}</TableCell>
                                            <TableCell align="right" className={classes.blue}>{row.inpcAcum ? row.inpcAcum + "%" : '-'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </MyTable>
                        </div>

                        {dataChart ?
                            <div className={classes.divChart}>
                                <div className={'chartHeader'}>
                                    <Typography variant={'body1'}>IPCA x INPC</Typography>
                                    <MySelect
                                        style={{ marginRight: '8px' }}
                                        value={typeChartSelected}
                                        verysmall
                                        onChange={(e) => handleChangeTypeChartYear(e.target.value)}
                                        options={typesChart.map((row, index) => (
                                            <option key={'type-chart-' + index} value={index}>{row}</option>
                                        ))}
                                    />
                                    <MySelect
                                        value={yearChartSelected}
                                        verysmall
                                        onChange={(e) => handleChangeChartYear(e.target.value)}
                                        options={years.map((row, index) => (
                                            <option key={'chart-year-' + index} value={index}>{row}</option>
                                        ))}
                                    />
                                </div>
                                <div className={'chartWrapper'}>
                                    <Line data={dataChart} options={optionsChart2} />
                                </div>
                            </div>
                            : null
                        }
                    </div>
                }

                {/* Tab 1: SELIC / CDI / IPCA */}
                {tabValue === 1 &&
                    <div className={classes.main}>
                        <div className={classes.divTable}>
                            <MyTable stickyHeader size="small" selectable='true'>
                                <colgroup>
                                    <col width="28%" />
                                    <col width="24%" />
                                    <col width="24%" />
                                    <col width="24%" />
                                </colgroup>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">Ano</TableCell>
                                        <TableCell align="right">SELIC</TableCell>
                                        <TableCell align="right">CDI</TableCell>
                                        <TableCell align="right">IPCA</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selicCdiIpcaToShow.map((row) => (
                                        <TableRow
                                            key={'selic-cdi-ipca-' + row.year}
                                            onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                                path: 'newSelicCdiIpca',
                                                data: row,
                                            }))}>
                                            <TableCell align="left">{row.year}</TableCell>
                                            <TableCell align="right" className={classes.blue}>{row.selicAcum ? row.selicAcum + "%" : '-'}</TableCell>
                                            <TableCell align="right" className={classes.blue}>{row.cdiAcum ? row.cdiAcum + "%" : '-'}</TableCell>
                                            <TableCell align="right" className={classes.blue}>{row.ipcaAcum ? row.ipcaAcum + "%" : '-'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </MyTable>
                        </div>
                    </div>
                }

            </div>

        </div>
    );
}
